<template>
    <div class="row">
        <div class="col-lg-12">
            <div class="createOrdersBody">

                <div class="card-content">
                    <div class="card-body">
                        <div class="form-body">
                            <form id="public-appointment-form" @submit.prevent :action="'/appointment/book-appointment'">
                                <input type="hidden" v-model="item.store_id" id="">
                                <details_form ref="details_form" :google_api="google_api"></details_form>

                                <div class="col-12" align="right">
                                    <submit_button text="Submit <i class='fas fa-paper-plane'></i>" :processing="processing"
                                        @clicked="create"></submit_button>
                                </div>

                            </form>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>
    
<script>
import Select2 from 'v-select2-component';
import select_location from './../../reusable-components/select_location';
import select_customer_type from './../../reusable-components/user/customer_type';
import VueCtkDateTimePicker from "vue-ctk-date-time-picker";
import "vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css";
import submit_button from './../../reusable-components/submit_button';
import details_form from './details_form';

export default {
    components: {
        Select2,
        select_location,
        VueCtkDateTimePicker: VueCtkDateTimePicker,
        select_customer_type: select_customer_type,
        submit_button: submit_button,
        details_form: details_form,
    },
    props: {
        user_id: { default: "" },
        google_api: { default: null },
        tenant_id: { default: null },
        assigned_to:{default:null},
        slot_data:{default:null}
    },
    mounted(){
     const vm = this;
     if(vm.slot_data != null){
        vm.$refs.details_form.item.appointment_time = vm.slot_data.from;
        vm.item.slot_id = vm.slot_data.id;
        vm.$refs.details_form.item.duration = vm.calculateTimeDuration();
        vm.$refs.details_form.disable_date = true;
     }
    },
    data() {
        return {
            appointment_time: '',
            customer_id: this.user_id,
            processing: false,
            item: {
                appointment_time: null,
                detail: null,
                devices: null,
                duration: null,
                subject: null,
                color: null,
                appointment_medium: "",
                phone_number: null,
                address: null,
                appointment_type: "",
                store_id: null,
                Appoinment_data:true,
                assigned_to:null,
                slot_id:null
            },

        }
    },
    methods: {
        calculateTimeDuration() {
            const fromDate = new Date(this.slot_data.from);
            const toDate = new Date(this.slot_data.to);
            const timeDifference = toDate - fromDate;
            const hours = Math.floor(timeDifference / 3600000);
            const minutes = Math.floor((timeDifference % 3600000) / 60000);
            const seconds = Math.floor((timeDifference % 60000) / 1000);
            if (hours > 0) {
                return `${hours} ${hours === 1 ? 'hour' : 'hours'}`;
            } else if (minutes > 0) {
                return `${minutes} ${minutes === 1 ? 'minute' : 'minutes'}`;
            } else {
                return 'Less than a minute';
            }
            return `${hours} hours, ${minutes} minutes, ${seconds} seconds`;
        },
        create: function () {
            let vm = this;
            //form validation
            var validate = $("#public-appointment-form").validate({
                errorElement: 'span'
            });
            validate.form();
            if (validate.errorList.length > 0) {
                Vue.$toast.open({
                    message: 'Please fill the required fields.',
                    type: "error",
                });
            }
            else {
                if (vm.processing === true) {
                    return false;
                }
                vm.processing = true;
             
                vm.item.subject = vm.$refs.details_form.item.subject;
                vm.item.appointment_medium = vm.$refs.details_form.item.appointment_medium;
                vm.item.address = vm.$refs.details_form.item.address;
                vm.item.phone_number = vm.$refs.details_form.item.phone_number;
                vm.item.appointment_type = vm.$refs.details_form.item.appointment_type;
                vm.item.appointment_time = vm.$refs.details_form.item.appointment_time;
                vm.item.devices = vm.$refs.details_form.item.devices;
                vm.item.duration = vm.$refs.details_form.item.duration;
                vm.item.detail = vm.$refs.details_form.item.detail;
                vm.item.color = vm.$refs.details_form.item.color;
                vm.item.store_id = vm.tenant_id;
                vm.item.assigned_to = vm.assigned_to;
                
                axios.get('/appointment/book-appointment', { params: vm.item, })
                    .then(response => {
                        vm.processing = false
                        window.location.href = response.data.successData;
                    }).catch(function (errors) {
                        vm.processing = false
                        Vue.$toast.open({
                            message: 'Something went wrong',
                            type: "error",
                        });
                    });
            }

        },
    }
}
</script>
    